<script setup lang="ts">
interface Props {
  name?: string | null
}

const { name = null } = defineProps<Props>()

defineOptions({
  name: 'ChipIcon'
})
</script>

<template>
  <VIcon size="1.25rem" class="p-0.25" :icon="name" />
</template>
